import { render } from "./SearchArea.vue?vue&type=template&id=162acc52&scoped=true"
import script from "./SearchArea.vue?vue&type=script&lang=js"
export * from "./SearchArea.vue?vue&type=script&lang=js"

import "./SearchArea.vue?vue&type=style&index=0&id=162acc52&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162acc52"]])

export default __exports__